import config from '../config';
import {
  authHeader,
  customFetch,
  jsonHeader,
  handleResponse,
  commonRequestOptions,
} from '../helpers';

const endpointPath = config.api.API_URL + '/task_schedule';

export const taskScheduleService = {
  create,
  destroy,
};

/**
 * Assigns one or more tasks to a schedule.
 * @param {{ task_schedules: Array<{task_id: number, schedule_id: number}> }} items
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, message: string, task_schedules: Array }>}
 */
function create(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), ...jsonHeader() },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(endpointPath, requestOptions, signal).then(handleResponse);
}

/**
 * Removes one or more task-schedule assignments.
 * Does NOT delete the task entity.
 * @param {{ task_schedules: Array<{task_id: number, schedule_id: number}> }} items
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, message: string }>}
 */
function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), ...jsonHeader() },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(endpointPath, requestOptions, signal).then(handleResponse);
}
